<template>
    <div v-if="tags.length > 0" class="flex flex-wrap items-center text-xs mt-3">
        <div class="flex flex-wrap">
            <span v-for="tag in tags" :key="tag" class="bg-gray-300 px-2 rounded text-gray-600 leading-loose mt-1 mr-1">
                {{ tag }}
            </span>
        </div>
        <div v-if="plusMore && plusMore > 0" class="ml-2 mt-1">+{{ plusMore }} more</div>
    </div>
</template>

<script>
export default {
    props: {
        tags: {
            type: Array,
            required: true
        },
        plusMore: {
            type: Number,
            default: null
        }
    }
};
</script>
